import React from 'react';

interface OwnProps {}

type Props = OwnProps & React.FormHTMLAttributes<HTMLFormElement>;

const Form: React.ForwardRefRenderFunction<HTMLFormElement, Props> = ({ action, method, ...rest }, ref) => {
    // tslint:disable-next-line:jsx-ban-elements
    return <form ref={ref} action={action || '#'} method={method || 'post'} {...rest} />;
};

Form.displayName = 'Form';

export default React.forwardRef<HTMLFormElement, Props>(Form);
